<ng-container *ngIf="!(remoteDiagnosticsStore.isParameterListEmpty(gatewaySerial) | async)">
  <ng-container
    *ngIf="
      remoteDiagnosticsUseCasesStore.getSelectedExtendedParametersTab(gatewaySerial)
        | async as currentTab
    "
  >
    <button
      mat-raised-button
      class="add-parameter-btn-mobile !hidden lt-md:!flex"
      color="primary"
      (click)="openModal(currentTab)"
    >
      <mat-icon>add</mat-icon>
      <span>{{
        currentTab === ExtendedParametersTabsEnum.SearchedParameters
          ? ('GENERAL.BUTTON.ADD_PARAMETER' | translate)
          : ('DIAGNOSTICS.CHOOSE_USE_CASE' | translate)
      }}</span>
    </button>
    <mat-form-field class="interval-select-mobile !hidden lt-md:!block" mat-select-height-large>
      <mat-label>{{ 'DIAGNOSTICS.READ_INTERVAL' | translate }}</mat-label>
      <mat-select
        class="interval-select-mobile__mat-select"
        [disabled]="
          !(remoteDiagnosticsStore.isAnyParameterStoppedAndSelected(gatewaySerial) | async)
        "
        [(value)]="interval"
        (selectionChange)="onIntervalChange($event)"
        fieldTextContentTooltip
      >
        <mat-option
          *ngFor="let i of remoteDiagnosticsStore.getAvailableIntervals$ | async"
          [value]="i"
          gtm="onSelect"
          gtmAction="Set interval to all selected - value picked: '{{ i }}'"
          gtmCategory="diagnosticsPageHeader"
          fieldTextContentTooltip
        >
          {{ i | msToSeconds }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="management-tab-container">
      <div class="management-tab-container__wrapper flex flex-row justify-between items-center">
        <div class="flex flex-row gap-[24px]">
          <mat-checkbox
            [(ngModel)]="selectAll"
            class="management-tab-container__checkbox lt-md:!hidden"
            (change)="onSelectAllChange($event)"
            >{{ 'GENERAL.CHECKBOX.SELECT_ALL' | translate }}</mat-checkbox
          >
          <mat-form-field mat-select-height-small class="lt-md:!hidden">
            <mat-select
              class="management-tab-container__mat-select"
              [(value)]="interval"
              [disabled]="
                !(
                  remoteDiagnosticsStore.isAnyParameterStoppedAndSelectedAndNotInError(
                    gatewaySerial
                  ) | async
                )
              "
              (selectionChange)="onIntervalChange($event)"
              fieldTextContentTooltip
            >
              <mat-option
                *ngFor="let i of remoteDiagnosticsStore.getAvailableIntervals$ | async"
                [value]="i"
                gtm="onSelect"
                gtmAction="Set interval to all selected - value picked: '{{ i }}'"
                gtmCategory="diagnosticsPageHeader"
                fieldTextContentTooltip
              >
                {{ i | msToSeconds }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="flex flex-row gap-[25px] justify-start items-center">
            <mat-icon
              [class.disabled]="
                !interval ||
                !(
                  remoteDiagnosticsStore.isAnyParameterStoppedAndSelectedAndNotInError(
                    gatewaySerial
                  ) | async
                ) ||
                selectedOrStartedParameters?.length > 10 ||
                (remoteDiagnosticsStore.isAnyParameterLoading(gatewaySerial) | async) ||
                (remoteDiagnosticsStore.scheduleMultipleParametersReadCycleInProgress$ | async)
              "
              (click)="startAllSelected()"
              >play_arrow</mat-icon
            >

            <mat-icon
              [class.disabled]="!isAnyParameterRunningAndSelected"
              (click)="stopAllSelected()"
              >stop</mat-icon
            >
            <img
              icon
              [class.disabled]="disableClearAllButton"
              (click)="clearSelectedSeries()"
              class="eraser-icon"
              src="assets/icons/eraser.svg"
            />
            <mat-icon
              gtm="onOpen"
              gtmAction="Delete all selected parameters confirmation"
              gtmCategory="diagnosticsPage"
              [class.disabled]="
                !(remoteDiagnosticsStore.isAnyParameterSelected(gatewaySerial) | async)
              "
              [viConfirm]="{
                title: 'DIAGNOSTICS.DELETE_PARAMETERS.CONFIRM.TITLE' | translate,
                content: 'DIAGNOSTICS.DELETE_PARAMETERS.CONFIRM.CONTENT' | translate,
                cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                confirmBtn: 'GENERAL.BUTTON.DELETE' | translate
              }"
              (confirm)="deleteAllSelected()"
              (cancel)="
                gtmService.track(
                  'onCancel',
                  'Delete all selected parameters confirmation',
                  'diagnosticsPage'
                )
              "
              class="delete-icon"
              >delete</mat-icon
            >
          </div>
        </div>
        <div
          class="management-tab-container__button-wrapper flex flex-row justify-start items-center"
        >
          <mat-icon
            class="info-icon"
            (mouseover)="showPopover = true"
            (mouseleave)="showPopover = false"
            (click)="showPopover = !showPopover"
            >info_outline</mat-icon
          >
          <div
            *ngIf="showPopover"
            class="management-tab-container__popover flex flex-col gap-[8px]"
          >
            <p>{{ 'DIAGNOSTICS.LEGEND' | translate }}</p>
            <span
              ><img icon class="eraser-icon" src="assets/icons/eraser.svg" />{{
                'DIAGNOSTICS.CLEAR_CHART' | translate
              }}</span
            >
            <span><mat-icon>delete</mat-icon>{{ 'DIAGNOSTICS.REMOVE_TILE' | translate }}</span>
            <span><mat-icon>save</mat-icon>{{ 'DIAGNOSTICS.SAVE_DATA' | translate }}</span>
            <span>
              <img icon class="crossed-out-icon" src="assets/icons/graph-crossed-out.svg" />{{
                'DIAGNOSTICS.INFOGRAPHIC_NOT_AVAILABLE' | translate
              }}
            </span>
          </div>
          <button
            class="infographic-btn"
            mat-stroked-button
            [disabled]="disableGoToInfographicButton"
            (click)="scrollToGraph()"
          >
            <mat-icon>bar_chart</mat-icon>
            <span>{{ 'DIAGNOSTICS.GO_TO_INFOGRAPHIC' | translate }}</span>
          </button>
          <button
            mat-raised-button
            class="add-parameter-btn"
            data-at-add-parameter
            color="primary"
            (click)="openModal(currentTab)"
          >
            <mat-icon>add</mat-icon>
            <span>{{
              currentTab === ExtendedParametersTabsEnum.SearchedParameters
                ? ('GENERAL.BUTTON.ADD_PARAMETER' | translate)
                : ('DIAGNOSTICS.CHOOSE_USE_CASE' | translate)
            }}</span>
          </button>
        </div>
        <div class="management-tab-container__button-tablet-wrapper flex flex-row gap-[16px]">
          <button
            class="infographic-btn"
            mat-stroked-button
            [disabled]="disableGoToInfographicButton"
            (click)="scrollToGraph()"
          >
            <mat-icon>bar_chart</mat-icon>
            <span>{{ 'DIAGNOSTICS.GO_TO_INFOGRAPHIC' | translate }}</span>
          </button>
          <button
            mat-raised-button
            class="add-parameter-btn"
            color="primary"
            (click)="openModal(currentTab)"
          >
            <mat-icon>add</mat-icon>
            <span>{{
              currentTab === ExtendedParametersTabsEnum.SearchedParameters
                ? ('GENERAL.BUTTON.ADD_PARAMETER' | translate)
                : ('DIAGNOSTICS.CHOOSE_USE_CASE' | translate)
            }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="select-all-mobile !hidden lt-md:!block">
      <mat-checkbox
        class="management-tab-container__checkbox"
        [(ngModel)]="selectAll"
        (change)="onSelectAllChange($event)"
        >{{ 'GENERAL.CHECKBOX.SELECT_ALL' | translate }}</mat-checkbox
      >
    </div>
  </ng-container>
</ng-container>
